
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { NewsTable } from "./NewsTable";
import { NewsArticle } from "./NewsManagement";

interface NewsArticlesSectionProps {
  title: string;
  articles: NewsArticle[];
  onDelete: (id: number) => void;
  onTogglePublic: (id: number) => void;
}

export function NewsArticlesSection({ 
  title, 
  articles, 
  onDelete, 
  onTogglePublic 
}: NewsArticlesSectionProps) {
  return (
    <Card className="md:col-span-2">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <NewsTable 
          articles={articles}
          onDelete={onDelete}
          onTogglePublic={onTogglePublic}
        />
      </CardContent>
    </Card>
  );
}
